<template>
  <div v-if="news.length" class="hs-news-content" id="news-list">
    <ul id="primary-news">
      <li
        v-for="singleNews in firstTwoNews"
        :key="singleNews.id"
        class="single-news"
        :class="{ 'has-photo': singleNews.image_path != null }"
      >
        <a
          target="_blank"
          rel="noopener noreferrer"
          :href="singleNews.url"
          @click.prevent="onNewsClick(singleNews)"
        >
          <div
            v-if="singleNews.image_path != null"
            class="news-photo"
            v-bind:style="{
                            'background-image':
                                'url(' + singleNews.image_path + ')'
                        }"
          ></div>
          <div class="titles">
            <strong>{{ singleNews.bold_title }}</strong>
            {{ singleNews.title }}
            <strong>{{ singleNews.cta }}</strong>
          </div>
        </a>
      </li>
    </ul>
    <!--  -->
    <perfect-scrollbar>
    <ul id="secondary-news" class="scrollable">
      <li
        v-for="singleNews in allExceptFirstTwoNews"
        :key="singleNews.id"
        class="single-news"
        :class="{ 'has-photo': singleNews.image_path != null }"
      >
        <a
          target="_blank"
          rel="noopener noreferrer"
          :href="singleNews.url"
          @click.prevent="onNewsClick(singleNews)"
        >
          <div
            v-if="singleNews.image_path != null"
            class="news-photo"
            v-bind:style="{
                            'background-image':
                                'url(' + singleNews.image_path + ')'
                        }"
          ></div>
          <div class="titles">
            <strong>{{ singleNews.bold_title }}</strong>
            {{ singleNews.title }}
            <strong>{{ singleNews.cta }}</strong>
          </div>
        </a>
      </li>
    </ul>
    </perfect-scrollbar>
  </div>
</template>

<script>
import jsonNews from "@/generated/news.json";

export default {
  data() {
    return {
      news: {}
    };
  },
  computed: {
      firstTwoNews: function () {
        return this.news.slice(0, 2);
      },
      allExceptFirstTwoNews: function () {
        return this.news.slice(2, this.news.length)
      }
  },
  methods: {
    sendNewsAnalytics: function(newsTitle) {
    //   ga("send", "event", "z ostatniej chwili", "text click", newsTitle);
    },
    onNewsClick: function (news) {
      this.sendNewsAnalytics(news.title);
      if (news.inside_url == 0) {
        window.open(news.url, '_blank');
      } else {
        this.$scrollTo(news.url, 300, {
            offset: -100
        });
      }
    }
  },
  mounted() {
    let cmp = this;
    cmp.news = jsonNews;

    setTimeout(function () {
        let mainNewsHeight = document.getElementById('main_news').offsetHeight;
        document.getElementById('news-list').style.maxHeight = mainNewsHeight + 'px';

        // max wysokosc drugiej listy newsow
        let primaryList = document.getElementById('primary-news');
        let secondaryList = document.getElementById('secondary-news');
        let newsListContainer = document.getElementById('news-list');
        secondaryList.style.maxHeight = newsListContainer.offsetHeight - primaryList.offsetHeight + 'px';
        
        // init scrollbara
        let scrollable = document.getElementsByClassName('ps');
        scrollable[0].dispatchEvent(new CustomEvent('scroll'))

    }, 300);
    
    window.addEventListener("resize", function() {
        let mainNewsHeight = document.getElementById('main_news').offsetHeight;
        document.getElementById('news-list').style.maxHeight = mainNewsHeight + 'px';

        // max wysokosc drugiej listy newsow
        let primaryList = document.getElementById('primary-news');
        let secondaryList = document.getElementById('secondary-news');
        let newsListContainer = document.getElementById('news-list');
        secondaryList.style.maxHeight = newsListContainer.offsetHeight - primaryList.offsetHeight + 'px';
    });
  },
};
</script>

<style lang="scss">
    .ps__rail-y {
      opacity: 0.6 !important;
      // display: block !important;
      
      &:before {
        content: "";
        background: #fff;
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 12px;
        z-index: 99;
      }

      &:after {
        content: "";
        background: #fff;
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        height: 12px;
        z-index: 99;
      }
    }

    .ps__thumb-y {
      right: 4px !important;
      border-radius: 0px !important;
    }
</style>

<style lang="scss">
@import "@/scss/_general.scss";

.hs-news-content {
  padding-bottom: 12px;
  border: 3px #FF5A00 solid;
  max-height: 340px;
  // overflow-y: scroll;
  overflow: hidden;
  background: #fff;

  scrollbar-width: thin;
  scrollbar-color: #CFD8DC #CFD8DC;

  ul {
    &.scrollable {
    //   overflow-y: scroll;
      // max-height: 200px;

    //   &::-webkit-scrollbar {
    //     width: 12px;
    //   }

    //   &::-webkit-scrollbar-track {
    //     background: transparent;
    //   }

    //   &::-webkit-scrollbar-thumb {
    //     background-color: #CFD8DC;
    //     border: 4px solid #fff;
    //     border-radius: 4px;
    //     width: 8px;
    //   }

      li.single-news {
        &:last-child {
          border-bottom: 0px;
        }
      }
    }

    li.single-news {
      padding: 6px $desktopGutter;
      border-bottom: 2px rgba(128, 128, 128, 0.2) solid;
      display: flex;

      @media only screen and (max-width: 1200px) {
        padding: 8px $desktopGutter;
      }

      a {
        color: $headingText;
        text-decoration: none;
        font-size: 14px;
        line-height: 20px;
        font-weight: 100;
        width: 100%;
        display: flex;
        align-items: center;

        .titles {
            display: flex;
            flex-direction: column;

            strong {
                font-weight: 400;
            }
        }

        &:hover {
          color: lighten($headingText, 30%);
        }
      }

      &.has-photo {
        // display: flex;

        .news-photo {
          width: 25%;
          max-width: 100px;
          height: 58px;
          background: red;
          float: left;
          margin-right: 15px;
          background-position: 50% 50% !important;
          background-size: cover !important;
          background-repeat: no-repeat !important;
        }
      }
    }
  }
}
</style>
